const convertStringToNumber = (value: string): number => {
  const number = Number(value);

  return number || 0;
};

export default convertStringToNumber;
